import { Button } from "@mui/material"
import { useState } from "react"
import AddStaff from "../modals/AddStaff"
import {
  getAllStaff,
  getStaffFilters,
  getStaffSort,
} from "../../api"
import ListData from "../common/ListData"
import EventListCard from "../cards/EventListCard"
import AddRoundedIcon from "@mui/icons-material/AddRounded"
import StaffCard from "../cards/StaffCard"

const Staff = () => {
  const [addStaffModal, setAddStaffModal] = useState(false)

  const [fetchData, setFetchData] = useState(false)

  const CTA = () => (
    <Button
    onClick={() => setAddStaffModal(true)}
      variant="contained"
      startIcon={<AddRoundedIcon />}
    >
      Add Staff
    </Button>
  )

  return (
    <>
      <ListData
        getFilters={getStaffFilters}
        getSort={getStaffSort}
        getAllData={getAllStaff}
        initialFilters={{}}
        HeaderRight={CTA}
        Card={StaffCard}
      />
      <AddStaff
        isOpen={addStaffModal}
        close={() => setAddStaffModal(false)}
      />
      {/* <AddEvent
        isOpen={editModal}
        isEdit={isEdit}
        close={closeEditModal}
        data={selectedEvent}
      />
      <DeleteEvent
        isOpen={deleteModal}
        close={closeDeleteModal}
        data={selectedEvent}
      /> */}
    </>
  )
}

export default Staff
